export default () => {
  const form = document.querySelector('[data-cart-form]');

  if (form) {
    // elements
    const els = {
      termsInput: document.querySelector('[data-cart-form-terms]'),
      checkoutButton: document.querySelector('[data-cart-form-checkout]'),
      validationText: document.querySelector('[data-cart-form-error-text]'),
    };

    // handlers
    const handleSubmit = (e) => {
      if (!els.termsInput.checked) {
        e.preventDefault();
        els.validationText.innerHTML = 'Please agree to the shipping terms and conditions before proceeding to checkout.';
      }
    };

    // event listeners
    form.addEventListener('submit', handleSubmit);
  }
};
